<template>
  <div class="team-section-grid animate-box" :style="getStyle()">
    <p class="staff-label">{{name}}</p>
    <div class="overlay-section">
      <div class="desc">
        <h3>{{name}}</h3>
        <span>{{role}}</span>
        <p>{{message}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Staff',
  props: {
    image: {
      type: String,
      default: '',
      required: true
    },
    name: {
      type: String,
      default: '',
      required: true
    },
    role: {
      type: String,
      default: 'スタッフ',
      required: true
    },
    message: {
      type: String,
      default: '',
      required: true
    }
  },
  methods: {
    getStyle() {
      return 'background-image: url(/static/' + this.image + ');'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.team-section-grid{
  position: relative;
}
.staff-label{
  color: #fff;
  font-weight: 900;
  background: rgba(0, 0, 0, 0.3);
  position: absolute;
  bottom: 0;
  width: 100%;
}
.staff-label small{
  font-weight: 400;
  font-size: 14px;
  color: #ddd;
}
</style>



// WEBPACK FOOTER //
// src/components/Staff.vue